import { default as aboutsU1exuB0UpMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as events8fQwLZHu2nMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93s7wpDPlCoIMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplegob1ZWIfgdMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsK07633GlsZMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93TcVtxNoOQsMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewMADozbkP7hMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index0eevK7g8CCMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93YMWzBG4DhEMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexLfk3GtBiM1Meta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93VbhdacdqlQMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexg4sYVC2jRKMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsEHRkgXI03MMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsaW3rHgAQANMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsh9nCcpTovXMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_9322izEJRetFMeta } from "/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as index2sGZoED1f2Meta } from "/tmp/build_f381faef/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmY8PUJf8eeJMeta } from "/tmp/build_f381faef/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmLVjfnhnbizMeta } from "/tmp/build_f381faef/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendar1IqWfqhFaCMeta } from "/tmp/build_f381faef/pages/[studio_url]/calendar.vue?macro=true";
import { default as chat07MAKfx2vvMeta } from "/tmp/build_f381faef/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutwksG5fa3SrMeta } from "/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedBzAADkshv3Meta } from "/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersizlcqPkCGJMeta } from "/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93uWFAqdt6wbMeta } from "/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editL2RI4qwJCVMeta } from "/tmp/build_f381faef/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93xNkKyDxL8gMeta } from "/tmp/build_f381faef/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityyYaPc13J1gMeta } from "/tmp/build_f381faef/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93UEBkybcIWfMeta } from "/tmp/build_f381faef/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93ncG5htYQYGMeta } from "/tmp/build_f381faef/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardevXoFKpCl5Meta } from "/tmp/build_f381faef/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexWBfn9qlZ5eMeta } from "/tmp/build_f381faef/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkout6QuS4v0VZSMeta } from "/tmp/build_f381faef/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productxvt6jTF13hMeta } from "/tmp/build_f381faef/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsKIx10afl47Meta } from "/tmp/build_f381faef/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_930h7PV8f29GMeta } from "/tmp/build_f381faef/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexhmWrFzAqgmMeta } from "/tmp/build_f381faef/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93YOyuzGl8uSMeta } from "/tmp/build_f381faef/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93GbXxUo5JdrMeta } from "/tmp/build_f381faef/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexNPGbeY9IvoMeta } from "/tmp/build_f381faef/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93yoc09F9TIkMeta } from "/tmp/build_f381faef/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinruom62AJ6LMeta } from "/tmp/build_f381faef/pages/[studio_url]/join.vue?macro=true";
import { default as loginm20eNhTkmzMeta } from "/tmp/build_f381faef/pages/[studio_url]/login.vue?macro=true";
import { default as logoutuSsMmwX5eGMeta } from "/tmp/build_f381faef/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93RePf9mkpy7Meta } from "/tmp/build_f381faef/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_938aKYgYlzR3Meta } from "/tmp/build_f381faef/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93EDaQPRR5KJMeta } from "/tmp/build_f381faef/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesMh43RvbNYGMeta } from "/tmp/build_f381faef/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosYdys6sJzjNMeta } from "/tmp/build_f381faef/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinA10x4y9qUuMeta } from "/tmp/build_f381faef/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93JDYCQn0n1xMeta } from "/tmp/build_f381faef/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexFZGMSbg0vKMeta } from "/tmp/build_f381faef/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index25CKgYAIKhMeta } from "/tmp/build_f381faef/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutc1kQKw8MoBMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentUk6w0oIfX4Meta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsFCt4C8aamqMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_932z89hkOPXZMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleyCausXwg20Meta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsgJ1N04KEVKMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93bVSg6sDI1xMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view2w6wCTJt8vMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexxgRBzGlsmwMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_932aN4crnpihMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexbNfQRjExC3Meta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93j4ylDvKYBDMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexZifbyS5rxUMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsHZXiZW4cU9Meta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsSFO6cEY3u9Meta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews1aVO8mzcigMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93BiBqgehulzMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexkdd0qfhE2mMeta } from "/tmp/build_f381faef/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexLKIBEEZoDJMeta } from "/tmp/build_f381faef/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchases0duRdHnlY6Meta } from "/tmp/build_f381faef/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsNivVbqqTXnMeta } from "/tmp/build_f381faef/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93W3WJT9kVECMeta } from "/tmp/build_f381faef/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93yTVDlGyNWGMeta } from "/tmp/build_f381faef/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetSfT9M2WRZmMeta } from "/tmp/build_f381faef/pages/[studio_url]/reset.vue?macro=true";
import { default as shopMO6qUtKGX1Meta } from "/tmp/build_f381faef/pages/[studio_url]/shop.vue?macro=true";
import { default as signupeKRjHWqKVpMeta } from "/tmp/build_f381faef/pages/[studio_url]/signup.vue?macro=true";
import { default as liveylc4cAcqWDMeta } from "/tmp/build_f381faef/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsCJIGGUVV20Meta } from "/tmp/build_f381faef/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93KAxWchwpDrMeta } from "/tmp/build_f381faef/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactdvV7GzgHOMMeta } from "/tmp/build_f381faef/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullwfbLUyrGyLMeta } from "/tmp/build_f381faef/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_9322izEJRetFMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_9322izEJRetFMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_9322izEJRetFMeta || {},
    alias: _91product_id_9322izEJRetFMeta?.alias || [],
    redirect: _91product_id_9322izEJRetFMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutsU1exuB0UpMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutsU1exuB0UpMeta?.path ?? "about",
    meta: aboutsU1exuB0UpMeta || {},
    alias: aboutsU1exuB0UpMeta?.alias || [],
    redirect: aboutsU1exuB0UpMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: events8fQwLZHu2nMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: events8fQwLZHu2nMeta?.path ?? "events",
    meta: events8fQwLZHu2nMeta || {},
    alias: events8fQwLZHu2nMeta?.alias || [],
    redirect: events8fQwLZHu2nMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93s7wpDPlCoIMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93s7wpDPlCoIMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93s7wpDPlCoIMeta || {},
    alias: _91media_id_93s7wpDPlCoIMeta?.alias || [],
    redirect: _91media_id_93s7wpDPlCoIMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplegob1ZWIfgdMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45samplegob1ZWIfgdMeta?.path ?? "free-sample",
    meta: free_45samplegob1ZWIfgdMeta || {},
    alias: free_45samplegob1ZWIfgdMeta?.alias || [],
    redirect: free_45samplegob1ZWIfgdMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsK07633GlsZMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsK07633GlsZMeta?.path ?? "included-products",
    meta: included_45productsK07633GlsZMeta || {},
    alias: included_45productsK07633GlsZMeta?.alias || [],
    redirect: included_45productsK07633GlsZMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93TcVtxNoOQsMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93TcVtxNoOQsMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93TcVtxNoOQsMeta || {},
    alias: _91media_id_93TcVtxNoOQsMeta?.alias || [],
    redirect: _91media_id_93TcVtxNoOQsMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewMADozbkP7hMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewMADozbkP7hMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewMADozbkP7hMeta || {},
    alias: viewMADozbkP7hMeta?.alias || [],
    redirect: viewMADozbkP7hMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index0eevK7g8CCMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: index0eevK7g8CCMeta?.path ?? "lessons",
    meta: index0eevK7g8CCMeta || {},
    alias: index0eevK7g8CCMeta?.alias || [],
    redirect: index0eevK7g8CCMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93YMWzBG4DhEMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93YMWzBG4DhEMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93YMWzBG4DhEMeta || {},
    alias: _91media_id_93YMWzBG4DhEMeta?.alias || [],
    redirect: _91media_id_93YMWzBG4DhEMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexLfk3GtBiM1Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexLfk3GtBiM1Meta?.path ?? "playlists/:playlist_id()",
    meta: indexLfk3GtBiM1Meta || {},
    alias: indexLfk3GtBiM1Meta?.alias || [],
    redirect: indexLfk3GtBiM1Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93VbhdacdqlQMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93VbhdacdqlQMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93VbhdacdqlQMeta || {},
    alias: _91media_id_93VbhdacdqlQMeta?.alias || [],
    redirect: _91media_id_93VbhdacdqlQMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexg4sYVC2jRKMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexg4sYVC2jRKMeta?.path ?? "playlists",
    meta: indexg4sYVC2jRKMeta || {},
    alias: indexg4sYVC2jRKMeta?.alias || [],
    redirect: indexg4sYVC2jRKMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsEHRkgXI03MMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsEHRkgXI03MMeta?.path ?? "private-sessions",
    meta: private_45sessionsEHRkgXI03MMeta || {},
    alias: private_45sessionsEHRkgXI03MMeta?.alias || [],
    redirect: private_45sessionsEHRkgXI03MMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsaW3rHgAQANMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsaW3rHgAQANMeta?.path ?? "recordings",
    meta: recordingsaW3rHgAQANMeta || {},
    alias: recordingsaW3rHgAQANMeta?.alias || [],
    redirect: recordingsaW3rHgAQANMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsh9nCcpTovXMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsh9nCcpTovXMeta?.path ?? "reviews",
    meta: reviewsh9nCcpTovXMeta || {},
    alias: reviewsh9nCcpTovXMeta?.alias || [],
    redirect: reviewsh9nCcpTovXMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index2sGZoED1f2Meta?.name ?? "buy-product-product_id",
    path: index2sGZoED1f2Meta?.path ?? "/buy/product/:product_id()",
    meta: index2sGZoED1f2Meta || {},
    alias: index2sGZoED1f2Meta?.alias || [],
    redirect: index2sGZoED1f2Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmY8PUJf8eeJMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmY8PUJf8eeJMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmY8PUJf8eeJMeta || {},
    alias: confirmY8PUJf8eeJMeta?.alias || [],
    redirect: confirmY8PUJf8eeJMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmLVjfnhnbizMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmLVjfnhnbizMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmLVjfnhnbizMeta || {},
    alias: confirmLVjfnhnbizMeta?.alias || [],
    redirect: confirmLVjfnhnbizMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendar1IqWfqhFaCMeta?.name ?? "calendar",
    path: calendar1IqWfqhFaCMeta?.path ?? "/calendar",
    meta: calendar1IqWfqhFaCMeta || {},
    alias: calendar1IqWfqhFaCMeta?.alias || [],
    redirect: calendar1IqWfqhFaCMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chat07MAKfx2vvMeta?.name ?? "chat",
    path: chat07MAKfx2vvMeta?.path ?? "/chat",
    meta: chat07MAKfx2vvMeta || {},
    alias: chat07MAKfx2vvMeta?.alias || [],
    redirect: chat07MAKfx2vvMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93uWFAqdt6wbMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93uWFAqdt6wbMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93uWFAqdt6wbMeta || {},
    alias: _91group_id_93uWFAqdt6wbMeta?.alias || [],
    redirect: _91group_id_93uWFAqdt6wbMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutwksG5fa3SrMeta?.name ?? "community-groups-group_id-about",
    path: aboutwksG5fa3SrMeta?.path ?? "about",
    meta: aboutwksG5fa3SrMeta || {},
    alias: aboutwksG5fa3SrMeta?.alias || [],
    redirect: aboutwksG5fa3SrMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedBzAADkshv3Meta?.name ?? "community-groups-group_id-feed",
    path: feedBzAADkshv3Meta?.path ?? "feed",
    meta: feedBzAADkshv3Meta || {},
    alias: feedBzAADkshv3Meta?.alias || [],
    redirect: feedBzAADkshv3Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersizlcqPkCGJMeta?.name ?? "community-groups-group_id-members",
    path: membersizlcqPkCGJMeta?.path ?? "members",
    meta: membersizlcqPkCGJMeta || {},
    alias: membersizlcqPkCGJMeta?.alias || [],
    redirect: membersizlcqPkCGJMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editL2RI4qwJCVMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editL2RI4qwJCVMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editL2RI4qwJCVMeta || {},
    alias: community_45profile_45editL2RI4qwJCVMeta?.alias || [],
    redirect: community_45profile_45editL2RI4qwJCVMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93xNkKyDxL8gMeta?.name ?? "community-profile-id",
    path: _91id_93xNkKyDxL8gMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93xNkKyDxL8gMeta || {},
    alias: _91id_93xNkKyDxL8gMeta?.alias || [],
    redirect: _91id_93xNkKyDxL8gMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityyYaPc13J1gMeta?.name ?? "community",
    path: communityyYaPc13J1gMeta?.path ?? "/community",
    meta: communityyYaPc13J1gMeta || {},
    alias: communityyYaPc13J1gMeta?.alias || [],
    redirect: communityyYaPc13J1gMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93UEBkybcIWfMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93UEBkybcIWfMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93UEBkybcIWfMeta || {},
    alias: _91uuid_93UEBkybcIWfMeta?.alias || [],
    redirect: _91uuid_93UEBkybcIWfMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93ncG5htYQYGMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93ncG5htYQYGMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93ncG5htYQYGMeta || {},
    alias: _91unique_id_93ncG5htYQYGMeta?.alias || [],
    redirect: _91unique_id_93ncG5htYQYGMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardevXoFKpCl5Meta?.name ?? "dashboard",
    path: dashboardevXoFKpCl5Meta?.path ?? "/dashboard",
    meta: dashboardevXoFKpCl5Meta || {},
    alias: dashboardevXoFKpCl5Meta?.alias || [],
    redirect: dashboardevXoFKpCl5Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexWBfn9qlZ5eMeta?.name ?? "event-details-event_id",
    path: indexWBfn9qlZ5eMeta?.path ?? "/event/details/:event_id()",
    meta: indexWBfn9qlZ5eMeta || {},
    alias: indexWBfn9qlZ5eMeta?.alias || [],
    redirect: indexWBfn9qlZ5eMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkout6QuS4v0VZSMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkout6QuS4v0VZSMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkout6QuS4v0VZSMeta || {},
    alias: checkout6QuS4v0VZSMeta?.alias || [],
    redirect: checkout6QuS4v0VZSMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productxvt6jTF13hMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productxvt6jTF13hMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productxvt6jTF13hMeta || {},
    alias: select_45productxvt6jTF13hMeta?.alias || [],
    redirect: select_45productxvt6jTF13hMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsKIx10afl47Meta?.name ?? "events",
    path: eventsKIx10afl47Meta?.path ?? "/events",
    meta: eventsKIx10afl47Meta || {},
    alias: eventsKIx10afl47Meta?.alias || [],
    redirect: eventsKIx10afl47Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_930h7PV8f29GMeta?.name ?? "gifts-uuid",
    path: _91uuid_930h7PV8f29GMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_930h7PV8f29GMeta || {},
    alias: _91uuid_930h7PV8f29GMeta?.alias || [],
    redirect: _91uuid_930h7PV8f29GMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexhmWrFzAqgmMeta?.name ?? "gifts",
    path: indexhmWrFzAqgmMeta?.path ?? "/gifts",
    meta: indexhmWrFzAqgmMeta || {},
    alias: indexhmWrFzAqgmMeta?.alias || [],
    redirect: indexhmWrFzAqgmMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93YOyuzGl8uSMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93YOyuzGl8uSMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93YOyuzGl8uSMeta || {},
    alias: _91invitation_id_93YOyuzGl8uSMeta?.alias || [],
    redirect: _91invitation_id_93YOyuzGl8uSMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93GbXxUo5JdrMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93GbXxUo5JdrMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93GbXxUo5JdrMeta || {},
    alias: _91product_id_93GbXxUo5JdrMeta?.alias || [],
    redirect: _91product_id_93GbXxUo5JdrMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexNPGbeY9IvoMeta?.name ?? "index",
    path: indexNPGbeY9IvoMeta?.path ?? "/",
    meta: indexNPGbeY9IvoMeta || {},
    alias: indexNPGbeY9IvoMeta?.alias || [],
    redirect: indexNPGbeY9IvoMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93yoc09F9TIkMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93yoc09F9TIkMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93yoc09F9TIkMeta || {},
    alias: _91invitation_unique_id_93yoc09F9TIkMeta?.alias || [],
    redirect: _91invitation_unique_id_93yoc09F9TIkMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinruom62AJ6LMeta?.name ?? "join",
    path: joinruom62AJ6LMeta?.path ?? "/join",
    meta: joinruom62AJ6LMeta || {},
    alias: joinruom62AJ6LMeta?.alias || [],
    redirect: joinruom62AJ6LMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginm20eNhTkmzMeta?.name ?? "login",
    path: loginm20eNhTkmzMeta?.path ?? "/login",
    meta: loginm20eNhTkmzMeta || {},
    alias: loginm20eNhTkmzMeta?.alias || [],
    redirect: loginm20eNhTkmzMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutuSsMmwX5eGMeta?.name ?? "logout",
    path: logoutuSsMmwX5eGMeta?.path ?? "/logout",
    meta: logoutuSsMmwX5eGMeta || {},
    alias: logoutuSsMmwX5eGMeta?.alias || [],
    redirect: logoutuSsMmwX5eGMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93RePf9mkpy7Meta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93RePf9mkpy7Meta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93RePf9mkpy7Meta || {},
    alias: _91meeting_type_slug_93RePf9mkpy7Meta?.alias || [],
    redirect: _91meeting_type_slug_93RePf9mkpy7Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_938aKYgYlzR3Meta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_938aKYgYlzR3Meta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_938aKYgYlzR3Meta || {},
    alias: _91meeting_unique_id_938aKYgYlzR3Meta?.alias || [],
    redirect: _91meeting_unique_id_938aKYgYlzR3Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93EDaQPRR5KJMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93EDaQPRR5KJMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93EDaQPRR5KJMeta || {},
    alias: _91meeting_unique_id_93EDaQPRR5KJMeta?.alias || [],
    redirect: _91meeting_unique_id_93EDaQPRR5KJMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesMh43RvbNYGMeta?.name ?? "my-favorites",
    path: my_45favoritesMh43RvbNYGMeta?.path ?? "/my-favorites",
    meta: my_45favoritesMh43RvbNYGMeta || {},
    alias: my_45favoritesMh43RvbNYGMeta?.alias || [],
    redirect: my_45favoritesMh43RvbNYGMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosYdys6sJzjNMeta?.name ?? "my-studios",
    path: my_45studiosYdys6sJzjNMeta?.path ?? "/my-studios",
    meta: my_45studiosYdys6sJzjNMeta || {},
    alias: my_45studiosYdys6sJzjNMeta?.alias || [],
    redirect: my_45studiosYdys6sJzjNMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinA10x4y9qUuMeta?.name ?? "optin",
    path: optinA10x4y9qUuMeta?.path ?? "/optin",
    meta: optinA10x4y9qUuMeta || {},
    alias: optinA10x4y9qUuMeta?.alias || [],
    redirect: optinA10x4y9qUuMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93JDYCQn0n1xMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93JDYCQn0n1xMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93JDYCQn0n1xMeta || {},
    alias: _91episode_id_93JDYCQn0n1xMeta?.alias || [],
    redirect: _91episode_id_93JDYCQn0n1xMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexFZGMSbg0vKMeta?.name ?? "podcasts-podcast_id",
    path: indexFZGMSbg0vKMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexFZGMSbg0vKMeta || {},
    alias: indexFZGMSbg0vKMeta?.alias || [],
    redirect: indexFZGMSbg0vKMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index25CKgYAIKhMeta?.name ?? "podcasts",
    path: index25CKgYAIKhMeta?.path ?? "/podcasts",
    meta: index25CKgYAIKhMeta || {},
    alias: index25CKgYAIKhMeta?.alias || [],
    redirect: index25CKgYAIKhMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93BiBqgehulzMeta?.name ?? "product-product_id",
    path: _91product_id_93BiBqgehulzMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93BiBqgehulzMeta || {},
    alias: _91product_id_93BiBqgehulzMeta?.alias || [],
    redirect: _91product_id_93BiBqgehulzMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutc1kQKw8MoBMeta?.name ?? "product-product_id-about",
    path: aboutc1kQKw8MoBMeta?.path ?? "about",
    meta: aboutc1kQKw8MoBMeta || {},
    alias: aboutc1kQKw8MoBMeta?.alias || [],
    redirect: aboutc1kQKw8MoBMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentUk6w0oIfX4Meta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentUk6w0oIfX4Meta?.path ?? "digital-download-content",
    meta: digital_45download_45contentUk6w0oIfX4Meta || {},
    alias: digital_45download_45contentUk6w0oIfX4Meta?.alias || [],
    redirect: digital_45download_45contentUk6w0oIfX4Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsFCt4C8aamqMeta?.name ?? "product-product_id-events",
    path: eventsFCt4C8aamqMeta?.path ?? "events",
    meta: eventsFCt4C8aamqMeta || {},
    alias: eventsFCt4C8aamqMeta?.alias || [],
    redirect: eventsFCt4C8aamqMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_932z89hkOPXZMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_932z89hkOPXZMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_932z89hkOPXZMeta || {},
    alias: _91media_id_932z89hkOPXZMeta?.alias || [],
    redirect: _91media_id_932z89hkOPXZMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleyCausXwg20Meta?.name ?? "product-product_id-free-sample",
    path: free_45sampleyCausXwg20Meta?.path ?? "free-sample",
    meta: free_45sampleyCausXwg20Meta || {},
    alias: free_45sampleyCausXwg20Meta?.alias || [],
    redirect: free_45sampleyCausXwg20Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsgJ1N04KEVKMeta?.name ?? "product-product_id-included-products",
    path: included_45productsgJ1N04KEVKMeta?.path ?? "included-products",
    meta: included_45productsgJ1N04KEVKMeta || {},
    alias: included_45productsgJ1N04KEVKMeta?.alias || [],
    redirect: included_45productsgJ1N04KEVKMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93bVSg6sDI1xMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93bVSg6sDI1xMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93bVSg6sDI1xMeta || {},
    alias: _91media_id_93bVSg6sDI1xMeta?.alias || [],
    redirect: _91media_id_93bVSg6sDI1xMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view2w6wCTJt8vMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: view2w6wCTJt8vMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view2w6wCTJt8vMeta || {},
    alias: view2w6wCTJt8vMeta?.alias || [],
    redirect: view2w6wCTJt8vMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexxgRBzGlsmwMeta?.name ?? "product-product_id-lessons",
    path: indexxgRBzGlsmwMeta?.path ?? "lessons",
    meta: indexxgRBzGlsmwMeta || {},
    alias: indexxgRBzGlsmwMeta?.alias || [],
    redirect: indexxgRBzGlsmwMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_932aN4crnpihMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_932aN4crnpihMeta?.path ?? "media/:media_id()",
    meta: _91media_id_932aN4crnpihMeta || {},
    alias: _91media_id_932aN4crnpihMeta?.alias || [],
    redirect: _91media_id_932aN4crnpihMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexbNfQRjExC3Meta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexbNfQRjExC3Meta?.path ?? "playlists/:playlist_id()",
    meta: indexbNfQRjExC3Meta || {},
    alias: indexbNfQRjExC3Meta?.alias || [],
    redirect: indexbNfQRjExC3Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93j4ylDvKYBDMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93j4ylDvKYBDMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93j4ylDvKYBDMeta || {},
    alias: _91media_id_93j4ylDvKYBDMeta?.alias || [],
    redirect: _91media_id_93j4ylDvKYBDMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexZifbyS5rxUMeta?.name ?? "product-product_id-playlists",
    path: indexZifbyS5rxUMeta?.path ?? "playlists",
    meta: indexZifbyS5rxUMeta || {},
    alias: indexZifbyS5rxUMeta?.alias || [],
    redirect: indexZifbyS5rxUMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsHZXiZW4cU9Meta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsHZXiZW4cU9Meta?.path ?? "private-sessions",
    meta: private_45sessionsHZXiZW4cU9Meta || {},
    alias: private_45sessionsHZXiZW4cU9Meta?.alias || [],
    redirect: private_45sessionsHZXiZW4cU9Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsSFO6cEY3u9Meta?.name ?? "product-product_id-recordings",
    path: recordingsSFO6cEY3u9Meta?.path ?? "recordings",
    meta: recordingsSFO6cEY3u9Meta || {},
    alias: recordingsSFO6cEY3u9Meta?.alias || [],
    redirect: recordingsSFO6cEY3u9Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews1aVO8mzcigMeta?.name ?? "product-product_id-reviews",
    path: reviews1aVO8mzcigMeta?.path ?? "reviews",
    meta: reviews1aVO8mzcigMeta || {},
    alias: reviews1aVO8mzcigMeta?.alias || [],
    redirect: reviews1aVO8mzcigMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexkdd0qfhE2mMeta?.name ?? "product",
    path: indexkdd0qfhE2mMeta?.path ?? "/product",
    meta: indexkdd0qfhE2mMeta || {},
    alias: indexkdd0qfhE2mMeta?.alias || [],
    redirect: indexkdd0qfhE2mMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexLKIBEEZoDJMeta?.name ?? "profile",
    path: indexLKIBEEZoDJMeta?.path ?? "/profile",
    meta: indexLKIBEEZoDJMeta || {},
    alias: indexLKIBEEZoDJMeta?.alias || [],
    redirect: indexLKIBEEZoDJMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchases0duRdHnlY6Meta?.name ?? "profile-purchases",
    path: purchases0duRdHnlY6Meta?.path ?? "/profile/purchases",
    meta: purchases0duRdHnlY6Meta || {},
    alias: purchases0duRdHnlY6Meta?.alias || [],
    redirect: purchases0duRdHnlY6Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsNivVbqqTXnMeta?.name ?? "profile-redemptions",
    path: redemptionsNivVbqqTXnMeta?.path ?? "/profile/redemptions",
    meta: redemptionsNivVbqqTXnMeta || {},
    alias: redemptionsNivVbqqTXnMeta?.alias || [],
    redirect: redemptionsNivVbqqTXnMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93W3WJT9kVECMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93W3WJT9kVECMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93W3WJT9kVECMeta || {},
    alias: _91quiz_id_93W3WJT9kVECMeta?.alias || [],
    redirect: _91quiz_id_93W3WJT9kVECMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93yTVDlGyNWGMeta?.name ?? "reset-password-uid-token",
    path: _91token_93yTVDlGyNWGMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93yTVDlGyNWGMeta || {},
    alias: _91token_93yTVDlGyNWGMeta?.alias || [],
    redirect: _91token_93yTVDlGyNWGMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetSfT9M2WRZmMeta?.name ?? "reset",
    path: resetSfT9M2WRZmMeta?.path ?? "/reset",
    meta: resetSfT9M2WRZmMeta || {},
    alias: resetSfT9M2WRZmMeta?.alias || [],
    redirect: resetSfT9M2WRZmMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopMO6qUtKGX1Meta?.name ?? "shop",
    path: shopMO6qUtKGX1Meta?.path ?? "/shop",
    meta: shopMO6qUtKGX1Meta || {},
    alias: shopMO6qUtKGX1Meta?.alias || [],
    redirect: shopMO6qUtKGX1Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupeKRjHWqKVpMeta?.name ?? "signup",
    path: signupeKRjHWqKVpMeta?.path ?? "/signup",
    meta: signupeKRjHWqKVpMeta || {},
    alias: signupeKRjHWqKVpMeta?.alias || [],
    redirect: signupeKRjHWqKVpMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveylc4cAcqWDMeta?.name ?? "streaming-event_id-live",
    path: liveylc4cAcqWDMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveylc4cAcqWDMeta || {},
    alias: liveylc4cAcqWDMeta?.alias || [],
    redirect: liveylc4cAcqWDMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsCJIGGUVV20Meta?.name ?? "tips",
    path: tipsCJIGGUVV20Meta?.path ?? "/tips",
    meta: tipsCJIGGUVV20Meta || {},
    alias: tipsCJIGGUVV20Meta?.alias || [],
    redirect: tipsCJIGGUVV20Meta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93KAxWchwpDrMeta?.name ?? "waiver-uuid",
    path: _91uuid_93KAxWchwpDrMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93KAxWchwpDrMeta || {},
    alias: _91uuid_93KAxWchwpDrMeta?.alias || [],
    redirect: _91uuid_93KAxWchwpDrMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactdvV7GzgHOMMeta?.name ?? "widgets-calendars-compact",
    path: compactdvV7GzgHOMMeta?.path ?? "/widgets/calendars/compact",
    meta: compactdvV7GzgHOMMeta || {},
    alias: compactdvV7GzgHOMMeta?.alias || [],
    redirect: compactdvV7GzgHOMMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullwfbLUyrGyLMeta?.name ?? "widgets-calendars-full",
    path: fullwfbLUyrGyLMeta?.path ?? "/widgets/calendars/full",
    meta: fullwfbLUyrGyLMeta || {},
    alias: fullwfbLUyrGyLMeta?.alias || [],
    redirect: fullwfbLUyrGyLMeta?.redirect,
    component: () => import("/tmp/build_f381faef/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]